import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import TopActions from './TopActions';
import { columns, headerOne, headerTwo } from './config ';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const Component = ({
  theme,
  apiStatus,
  callback,
  history,
  Styled,
  handleExportCsaViolations,
  csaViolations,
  changeRequest,
  topAction,
  hasApiStatus,
  request,
  pagination,
  setPagination,
}) => {
  const { i18n } = useTranslation();
  const information =
    hasApiStatus && hasApiStatus.errorMessage ? (
      <Message type="error" s message={i18n.t(hasApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );

  const generateRows = () => {
    return csaViolations?.aaData || [];
  };

  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            {...{
              Styled,
              apiStatus,
              history,
              callback,
              hasApiStatus,
              changeRequest,
              i18n,
              handleExportCsaViolations,
              request,
              pagination,
              setPagination,
            }}
          />
        )}
        <Styled.TableWrapper>
          <div className="quickFilter"></div>
          <div className="tableWrapper">
            <Table
              type="server"
              baseRequest={request}
              changeRequest={changeRequest}
              title=""
              columns={columns}
              headerOne={headerOne}
              headerTwo={headerTwo}
              data={generateRows()}
              emptyMessage={information}
              itemsPerPage={15}
              totalRecords={csaViolations?.iTotalRecords}
              actions={[]}
              i18n={i18n}
              mergedColumn={true}
              position={3}
              pageinationReset={pagination}
              pagenationClicked={(e) => {
                setPagination(!e);
              }}
            />
          </div>
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </Box>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  fetchViolations: PropTypes.func.isRequired,
  handleExportCsaViolations: PropTypes.func.isRequired,
};

export default Component;
